<template>
  <div class="lp-sort-drop-down-container">

    <!-- Basic -->
    <div class="sort-drdn-select-wrapper" @click="openList" :style="wrapperStyle">
      <span class="sort-drdn-select-item" @click.stop.prevent="openList">{{ selectedVal }}</span>
      <i v-if="!isOpen" @click.stop.prevent="isOpen=true" class="material-icons sort-drdn-arrow-icon" :style="iconStyle">keyboard_arrow_down</i>
      <i v-if="isOpen" @click.stop.prevent="isOpen=false" class="material-icons sort-drdn-arrow-icon" :style="iconStyle">keyboard_arrow_up</i>
    </div>

    <div v-if="isOpen" class="sort-drdn-list-outsider" @click="isOpen=false"></div>
    <ul v-if="isOpen" class="sort-drdn-list">
      <li class="sort-drdn-item" v-for="(item, idx) in list" :key="'sort-list'+idx" @click="clickTargetItem(item)">
        <div class="flex"><div :style="preColor(item.value)"></div><div class="label">{{ item.label }}</div></div>
      </li>
    </ul>

  </div>
</template>

<script>
import moment from 'moment';


export default {
  props: [
    'data', 'placeholder', 'list',
    'width', 'listWidth', 'wrapPadding', 'bgColor', 'borderColor',
    'fontSize', 'wrapHeight', 'iconSize', 'wrapStyle'
  ],
  components: {

  },
  data() {
    return {
      isOpen: false,
      selectedVal: '',
    }
  },
  created() {
    if(this.data!==undefined) {

      if(this.data.lpcolor === undefined)
        this.selectedVal = '#%x%x%x'.format(this.data.r, this.data.g, this.data.b);
      else
        this.selectedVal = this.data.lpcolor;
    }
    else if ( this.placeholder !== undefined ) {
      this.selectedVal = this.placeholder;
    }

  },
  watch: {
    list(n) {
      this.selectedVal = this.placeholder;
    },
    data(n) {
      if(n === undefined) return;

      if(n.lpcolor === undefined) {
        this.selectedVal = '#%s%s%s'.format(this.hex(n.r), this.hex(n.g), this.hex(n.b));
      }
      else {
        this.selectedVal = n.lpcolor;
      }
    }
  },
  computed: {
    wrapperStyle() {
      let style = {
        width: '100%'
      };

      if ( this.wrapStyle !== undefined ) {
        style = this.wrapStyle;
      }
      if ( this.bgColor !== undefined ) {
        style.backgroundColor = this.bgColor;
      }
      if ( this.borderColor !== undefined ) {
        style.border = '1px solid ' + this.borderColor;
      }
      if ( this.fontSize !== undefined ) {
        style.fontSize = this.fontSize;
      }
      if ( this.wrapHeight !== undefined ) {
        style.height = this.wrapHeight;
      }
      if ( this.wrapPadding !== undefined ) {
        style.padding = this.wrapPadding;
      }

      if( this.type === 'date' ) {
        style.width = '100px';
      }

      return style;
    },
    iconStyle() {
      let style = {};

      if ( this.iconSize !== undefined ) {
        style.fontSize = this.iconSize;
      }

      return style;
    }
  },
  methods: {
    hex(val) {
      let dt = '%x'.format(val);
      if(dt.length === 1)
        dt = '0' + dt;

      return dt;
    },
    openList() {
      this.isOpen ? this.isOpen=false : this.isOpen=true;
      this.$root.$emit('openListType', this.type);
    },
    clickTargetItem(item) {
      this.selectedVal = item.label;
      this.$emit('onSelect', item.value);
      this.isOpen = false;
    },
    preColor(value) {
      /*let rgba = undefined;
      if(value !== undefined)
        rgba = find(this.$store.getters.brand.color_theme.data, "name", value).color;
      else
        rgba = value;
*/
      let color = 'width:16px; height:16px; border:1px solid #555; background-color:rgba(' + rgba.r + ',' + rgba.g + ',' + rgba.b + ',' + rgba.a +')';
      return color;
    }
  }
}
</script>


<style lang="stylus" type="stylus" scoped>
//@import '~assets/css/reset'
.lp-sort-drop-down-container
  font-size 0.9rem
  position relative
  padding 10px
  padding-top 0

.sort-drdn-select-wrapper
  background #f2f7f8
  display flex
  justify-content space-between
  align-items center
  border-radius 3px
  height 32px
  padding 8px 12px
  font-size .8rem
  cursor pointer
.sort-drdn-select-item
  display flex
  align-items center
  cursor pointer
  margin-right 4px
.sort-drdn-arrow-icon
  font-size 1.1rem
  color #064160
  cursor pointer
.sort-drdn-list
  position absolute
  bottom 32px
  width 100%
  left 0
  box-shadow 3px 4px 8px 0px #999
  background-color #fff
  border-radius 3px
  max-height 270px
  overflow-y auto
  z-index 10
  font-size .8rem
  cursor pointer
.sort-drdn-item
  background #fff
  padding 8px 12px
  cursor pointer
.sort-drdn-item:hover
  background #ddd
.sort-drdn-list-outsider
  position fixed
  top 0
  left 0
  right 0
  bottom 0
.label
  margin-left 8px
  line-height 16px
  padding-top 4px
  font-weight 400

.flex
  display flex
</style>
